// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'hand-book-open';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.563 9.804v6.75m0-1.124h11.25a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25-2.25H.562M4.5 13.18h2.25m1.52-2.708c2.537.381 3.355 1.275 3.355 1.275' />
    <path d='M5.813 8.166V1.71a.264.264 0 0 1 .267-.264c4.277.054 5.545 1.443 5.545 1.443m0 0v8.86s1.27-1.39 5.55-1.444a.265.265 0 0 0 .261-.264v-8.33a.264.264 0 0 0-.268-.265 16.42 16.42 0 0 0-2.374.197 7.374 7.374 0 0 0-3.169 1.246z' />
  </g>
);

export const viewBox = '0 0 18 18';
